export default "__VITE_ASSET__C4MrG4EU__"